import notFoundPic from '/images/404.png'

import { Layout } from '@/components/layout'

import classes from './styles.module.css'

export function NotFound() {
  return (
    <Layout wrapClassName={classes.root}>
      <div className={classes.container}>
        <img src={notFoundPic} alt="404" className={classes.image} />
        <p className={classes.text}>Страница не найдена</p>
      </div>
    </Layout>
  )
}
